<template>
    <q-dialog ref="client-table" persistent :maximized="maximizedToggle" transition-show="slide-up"
        transition-hide="slide-down" class="demographic-dialog" full-height>
        <q-card>
            <q-bar>
                <q-space />

                <q-btn dense flat icon="minimize" @click="maximizedToggle = false" :disable="!maximizedToggle">
                    <q-tooltip v-if="maximizedToggle" class="bg-white text-primary">Minimize</q-tooltip>
                </q-btn>
                <q-btn dense flat icon="crop_square" @click="maximizedToggle = true" :disable="maximizedToggle">
                    <q-tooltip v-if="!maximizedToggle" class="bg-white text-primary">Maximize</q-tooltip>
                </q-btn>
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip class="bg-white text-primary">Close</q-tooltip>
                </q-btn>
            </q-bar>
            <q-card-section>
                <div class="text-h4 text-center">{{ tableTitle }}</div>
                <div class="text-center">Note: Filters applied on the previous page will work here. Alternatively, you can use the search input.</div>
            </q-card-section>
            <q-card-section class="q-pt-none">
                <q-table class="waitlist-table" :rows="rows" :columns="columns" virtual-scroll row-key="id"
                :rows-per-page-options="[0]" :filter="filter" :filter-method="filterPauaClientTable">
                <template v-slot:top-left>
                    <q-input outlined borderless dense debounce="300" v-model="filter" placeholder="Name, NHI, email, phone, date of birth, ID or table details">
                        <template v-slot:append>
                            <q-icon name="close" @click="filter = ''" class="cursor-pointer" />
                            <q-icon name="search" />
                        </template>
                    </q-input>
                </template>
                <template v-slot:top-right>
                    <q-btn no-caps fab-mini flat icon="download" @click="exportTable(rows, 'Client Waitlist.csv', { columns: columns })" />
                </template>
            </q-table>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>

import { exportTable } from "../../services/util/file";
import { filterPauaClientTable } from "@/services/util/pauaClientSearch";

export default ({
    name: "ClientWaitlistTableModal",
    props: ['rows', 'columns', 'tableTitle'],
    methods: { filterPauaClientTable },


    data() {
        return {
            exportTable: exportTable,
            filter: '',
            maximizedToggle: true,
        }
    },

})

</script>

<style>
@import '../../assets/styles/clientDemographics.css';
</style>
